var map = {
	"./abnormal.png": "9e77",
	"./inspection.png": "14b3",
	"./normal.png": "daf7",
	"./point1.png": "82c2",
	"./point2.png": "924e",
	"./point3.png": "1663",
	"./scan.png": "c6c8",
	"./zhanwei.svg": "c039"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "879d";